import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex cursor-pointer justify-between gap-4 rounded-full xl:h-[48px]',
    prices: 'items-start',
    price: 'text-sm font-semibold xl:text-base xl:font-medium',
    oldPrice: 'text-text-inactive text-sm font-light xl:text-base',
    button: 'size-[48px]',
    yaSplitBadge: 'mt-[5px] px-[8px] lg:mt-[5px]',
    priceWrapper: 'flex flex-col'
  },
  variants: {
    null: {
      true: {
        base: 'cursor-default opacity-0'
      }
    },
    isInCart: {
      true: {
        button: ''
      }
    },
    variantBadge: {
      simple: {
        yaSplitBadge: 'mt-1 px-0 max-md:h-auto max-md:items-start md:mt-0'
      }
    }
  },
  defaultVariants: {
    null: false,
    isInCart: false
  }
});
